import AuthModule from '@/store/modules/auth.module';
import { RouteName } from '@/utils/constants';
import Vue from 'vue';
import VueRouter from 'vue-router';
import appRoutes from '@/router/routes';
import { getModule } from 'vuex-module-decorators';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: appRoutes(),
});

const authModule = getModule(AuthModule);

router.beforeEach((to, from, next) => {
  authModule.checkAccess(to)
    .then((hasAccess) => {
      if (hasAccess
        && ((authModule.isIdirUser
          && !to.matched.some((record) => (record.path === `/${RouteName.Main}`)))
          || (!authModule.isIdirUser
            && !to.matched.some((record) => (record.path === `/${RouteName.Ministry}`))))) {
        next();
      } else if (hasAccess && authModule.isIdirUser) {
        next(RouteName.Ministry);
      } else if (hasAccess) {
        next({ name: RouteName.Dashboard });
      } else if (authModule.isAuthenticated) {
        next('/unauthorized');
      } else {
        next('/');
      }
    });
});

export default router;
